module.exports = __webpack_public_path__ + "static/media/icon_my-bag_off.9bdb9888.svg";